<template>
  <div class="home">
  
    <Reproductor msg="Las estaciones" audio2="../mp3/PrimariaF/03PF.mp3" cover="../img/6.jpg" name="Primaria F - Lección #3"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
